import React from "react";
import "../assets/styles/Loader.css"

const Loader = () => {
  return (
    <div className="spinner-loader">
      <div className="flipping">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
